import { render, staticRenderFns } from "./StationMessageView.vue?vue&type=template&id=670166c0&scoped=true&"
import script from "./StationMessageView.vue?vue&type=script&lang=js&"
export * from "./StationMessageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670166c0",
  null
  
)

export default component.exports